import React from 'react';
import { useFormContext } from '../Form';
import { Tooltip } from '../Tooltip';
import { StyledLabel, StyledRequired, StyledStaticFieldLabel } from './Label.styled';
export function Label(props) {
  return /*#__PURE__*/React.createElement(StyledLabel, {
    htmlFor: props.htmlFor
  }, props.children, props.required && /*#__PURE__*/React.createElement(RequiredLabel, null), props.tooltip && /*#__PURE__*/React.createElement(Tooltip, null, props.tooltip));
}
export function RequiredLabel() {
  var formContext = useFormContext();
  if (!formContext.isForm) {
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledRequired, null, ' *');
}
export function StaticFieldLabel(props) {
  return /*#__PURE__*/React.createElement(StyledStaticFieldLabel, null, props.children, props.tooltip && /*#__PURE__*/React.createElement(Tooltip, null, props.tooltip));
}